import GamesList from './GamesList';

export default GamesList;
